export default {
    data: [
      { value: "waiting", text: { en: "Waiting", cn: "等待审查" } },
      { value: "rejected", text: { en: "Rejected", cn: "驳回" } },
      { value: "approved", text: { en: "Approved", cn: "审查通过" } },
    ],
  };
  